module.exports = __webpack_public_path__ + "img/ask-buzz-header.0ca783e0.png";